import { Calendar } from './apps/calendar';

const calendars = Array.prototype.slice.call(document.querySelectorAll('[data-bss-calendar]'));
calendars.forEach((root: HTMLElement) => {
  new Calendar(root);
});

